import Vue from "vue";
import { Store } from "vuex";
import { Action, Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

import { isModelStale, processCoreModelResponse } from "@/store/-utils";
import RetailerProductsApi from "@/store/retailer-products/-api";
import logger, { logLevel } from "@/utils/logger";

@Module({
  name: "retailer-products",
  stateFactory: true,
  namespaced: true,
})
export default class RetailerProductStore extends VuexModule {
  retailerProducts: RetailerProductsMap = {};

  @Action({ rawError: true })
  async fetchRetailerProductById(id: string) {
    // Skip refreshing recent models
    if (!isModelStale(this.retailerProducts[id])) {
      return;
    }

    try {
      const api = new RetailerProductsApi(this.store.$axios);
      const response = await api.get({ id, includes: ["policies"] });
      await processCoreModelResponse(this.store, response.data);
    } catch (error) {
      logger(logLevel.ERROR, "Error fetching retailer product by id", { productRetailerId: id }, error);
    }
  }

  @Mutation
  setRetailerProducts({ retailerProducts }: { retailerProducts: RetailerProductsMap }) {
    Vue.set(this, "retailerProducts", Object.assign({}, this.retailerProducts, retailerProducts));
  }
}

export const getRetailerProductsStore = (store: Store<unknown>) => {
  const productVariantsStore = getModule(RetailerProductStore, store);

  return productVariantsStore;
};
